import { inOutMotion, inOutZoom, slideUp } from "UI/motionStyles";

export const useAnimationStyles = ({
  direction,
  delayIn,
  delayOut,
  variant,
  snapHeight,
}) => {
  // TODO: Replace this with a new "slide" variant.
  if (direction) {
    return {
      initial: { y: direction === "top" ? -50 : 50, opacity: 0 },
      animate: {
        y: 0,
        opacity: 1,
        transition: { ...slideUp.transition, delay: delayIn },
      },
      exit: {
        y: direction === "top" ? -50 : 50,
        opacity: 0,
        transition: { delay: delayOut, ease: "easeOut" },
      },
    };
  }

  switch (variant) {
    case "fade":
      return {
        ...inOutMotion,
        initial: {
          ...inOutMotion.initial,
          height: snapHeight ? "auto" : inOutMotion.initial.height,
        },
        exit: {
          ...inOutMotion.exit,
          transition: { delay: delayOut },
          height: snapHeight ? "auto" : inOutMotion.exit.height,
        },
        animate: {
          ...inOutMotion.animate,
          transition: { ...inOutMotion.transition, delay: delayIn },
        },
      };
    case "scale":
    default:
      return {
        ...inOutZoom,
        initial: {
          ...inOutZoom.initial,
          height: snapHeight ? "auto" : inOutZoom.initial.height,
        },
        exit: {
          ...inOutZoom.exit,
          transition: { delay: delayOut },
          height: snapHeight ? "auto" : inOutZoom.exit.height,
        },
        animate: {
          ...inOutZoom.animate,
          transition: { ...inOutZoom.transition, delay: delayIn },
        },
      };
  }
};
